
const AssetExtension = {
    MODEL: '.iq3model',

    SCENE_STATE: '.iq3sstate',
    SESSION: '.iq3session',
    TAG: '.iq3tag',

    VIEWPOINT_GROUP: '.json',

    CABLE: '.csv',
	AVATAR: '.zip',
	ENVIRONMENT: '.zip',
};

module.exports = {
    AssetExtension
};
